<template>
  <div class="page">
    <a-row style="margin-bottom: 8px">
      <a-col :xs="24" :md="12" :lg="8">
        <h2 style="padding: 0 8px">app功能模块树形列表</h2>
        <a-tree :tree-data="tree.data" default-expand-all :default-selected-keys="tree.defaultSelectedKeys" @select="treeNodeSelect"></a-tree>
      </a-col>
      <a-col :xs="24" :md="12" :lg="14">
        <h2>编辑区</h2>
        <a-row style="margin: 8px 0">
          <a-button type="primary" @click="addNew(1)">添加子模块</a-button>
          <a-button style="margin-left: 8px" type="primary" @click="addNew(2)">添加根模块</a-button>
        </a-row>
        <a-form :form="editForm.form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" @submit="handleEditSubmit">
          <a-form-item label="功能名" :wrapper-col="{ span: 8 }">
            <a-input v-decorator="['title', { rules: [{ required: true, message: '请输入功能名' }] }]" />
          </a-form-item>
          <a-form-item label="KEY" :wrapper-col="{ span: 12 }">
            <a-input :addon-before="editForm.keyAddonBefore" v-decorator="['key', { rules: [{ required: true, message: '请输入功能KEY' }] }]" />
          </a-form-item>
          <a-form-item label="启用">
            <a-radio-group v-decorator="['enable']">
              <a-radio :value="1">启用</a-radio>
              <a-radio :value="0">不启用</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="类型" :wrapper-col="{ span: 8 }">
            <a-select v-model="editForm.type">
              <a-select-option v-for="item of typeEnum" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-show="editForm.type == 1" label="Url" :wrapper-col="{ span: 8 }">
            <a-input v-model="editForm.routerPath" />
          </a-form-item>
          <a-form-item :label="editForm.type == 1 ? 'ICON' : '操作key'" :wrapper-col="{ span: 8 }">
            <a-input v-model="editForm.icon" />
          </a-form-item>
          <a-form-item label="排序" :wrapper-col="{ span: 8 }">
            <a-input v-model="editForm.sort" />
          </a-form-item>
          <a-form-item label="描述" :wrapper-col="{ span: 8 }">
            <a-textarea v-model="editForm.desc" placeholder="输入对该模块的一些描述信息，限200字" :auto-size="{ minRows: 2, maxRows: 6 }"></a-textarea>
          </a-form-item>
          <a-form-item>
            <a-col :xs="{ span: 24, offset: 10 }">
              <a-button type="primary" html-type="submit" @click="editSave">保存</a-button>
              <a-button style="margin-left: 16px" @click="deleteMod">删除</a-button>
            </a-col>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <!--添加新功能模块模态框-->
    <a-modal :title="modalAddNew.type === 1 ? '添加子模块' : '添加根模块'" :visible="modalAddNew.show" :confirm-loading="modalAddNew.confirmLoading" :dialog-style="{
                minWidth: '700px',
                maxWidth: '900px',
                top: '30%',
                marginTop: '-100px',
            }" @ok="addNewConfirm" @cancel="addNewCancel">
      <a-form :form="modalAddNew.form" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-item label="父模块" :wrapper-col="{ span: 8 }" v-if="modalAddNew.type === 1">
          <a-input :disabled="true" v-model="modalAddNew.parentTitle" />
        </a-form-item>
        <a-form-item label="功能名" :wrapper-col="{ span: 8 }">
          <a-input v-decorator="['title', { rules: [{ required: true, message: '请输入功能名' }] }]" />
        </a-form-item>
        <a-form-item label="KEY">
          <a-input :addon-before="modalAddNew.keyAddonBefore" v-decorator="['key', { rules: [{ required: true, message: '请输入功能KEY' }] }]" />
        </a-form-item>
        <a-form-item label="排序号">
          <a-input v-decorator="['sort', { rules: [{ required: true, message: '请输入排序号' }] }]" />
        </a-form-item>
        <a-form-item label="启用">
          <a-radio-group v-decorator="['enable']">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">不启用</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="类型" :wrapper-col="{ span: 8 }">
          <a-select v-model="modalAddNew.modType">
            <a-select-option v-for="item of typeEnum" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-show="modalAddNew.modType == 1" label="Url" :wrapper-col="{ span: 8 }">
          <a-input v-model="modalAddNew.routerPath" />
        </a-form-item>
        <a-form-item :label="modalAddNew.modType == 1 ? 'ICON' : '操作key'" :wrapper-col="{ span: 8 }">
          <a-input v-model="modalAddNew.icon" />
        </a-form-item>
        <a-form-item label="描述">
          <a-textarea v-decorator="['desc']" placeholder="输入对该模块的一些描述信息，限200字" :auto-size="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import FuncModService from '@/service/FuncModService';
export default {
  name: 'FuncList',
  data () {
    return {
      typeEnum: [
        {
          value: 1,
          name: '模块',
        },
        {
          value: 2,
          name: '操作权限',
        },
      ],
      tree: {
        data: [],
        defaultSelectedKeys: [],
        currentNodeData: null,
      },
      editForm: {
        desc: null,
        type: 1,
        form: this.$form.createForm(this, { name: 'editForm' }),
        keyAddonBefore: null,
        routerPath: '',
        icon: '',
        sort: '',
      },
      modalAddNew: {
        type: 1, //1根模块，2子模块
        show: false,
        sort: '',//排序号
        confirmLoading: false,
        form: this.$form.createForm(this, { name: 'addNewForm' }),
        keyAddonBefore: null,
        parentTitle: '',
        modType: 1,
        routerPath: '',
        icon: '',
      },
      isRoot: false //判断是否是根模块
    };
  },
  mounted () {
    this.refreshTreeData();
  },
  methods: {
    //提交编辑
    handleEditSubmit (e) {
      e.preventDefaultEvent();
    },
    //点击节点
    treeNodeSelect (selectKeys, e) {
      console.log(selectKeys, e, '点击节点')
      let data = e.node.dataRef;
      // Object.keys(this.editForm).forEach(key => {
      //     this.editForm[key] = data[key];
      // });
      // return;
      this.tree.defaultSelectedKeys[0] = selectKeys[0];
      this.tree.currentNodeData = data;
      //计算key 前缀
      let keys = e.node.eventKey.split('-');
      let suffixKey = keys[keys.length - 1];
      keys.pop();
      let prefix = '';
      for (let key of keys) {
        prefix += key + '-';
      }
      this.$nextTick(() => {
        this.editForm.form.setFieldsValue({
          title: e.node.title,
          key: suffixKey,
          enable: data.enable ? 1 : 0,
          routerPath: data.routerPath,
          icon: data.icon,
        });
        this.editForm.keyAddonBefore = prefix;
        this.editForm.desc = data.desc;
        this.editForm.type = data.type;
        this.editForm.routerPath = data.routerPath;
        this.editForm.icon = data.icon;
        this.editForm.sort = data.sort;
        this.isRoot = e.node.pos.length > 3 ? false : true
      });
    },
    addNew (type) {
      this.modalAddNew.type = type;
      if (type === 1) {
        //子模块
        this.modalAddNew.parentTitle = this.tree.currentNodeData.title;
        this.modalAddNew.keyAddonBefore = this.tree.currentNodeData.key + '-';
      } else {
        this.modalAddNew.keyAddonBefore = null;
      }
      this.modalAddNew.show = true;
      this.$nextTick(() => {
        this.modalAddNew.form.setFieldsValue({
          enable: 1,
        });
      });
    },
    //添加新功能确认按钮点击
    addNewConfirm (e) {
      e.preventDefault();
      this.modalAddNew.form.validateFields((err, values) => {
        if (!err) {
          values.desc = values.desc ? values.desc : '';
          if (this.modalAddNew.type === 1) {
            values.parentId = this.tree.currentNodeData.id;
            values.key = this.modalAddNew.keyAddonBefore + values.key;
          } else {
            values.parentId = 0;
          }
          values.type = this.modalAddNew.modType;
          values.routerPath = this.modalAddNew.routerPath;
          values.icon = this.modalAddNew.icon;
          values.menuType = 2;
          FuncModService.create(values)
            .then(data => {
              this.$message.success('添加成功');
              this.modalAddNew.show = false;
              this.refreshTreeData();
            })
            .catch(e => {
              this.$message.error(e);
            });
        }
      });
    },
    //添加新功能：取消
    addNewCancel (e) {
      this.modalAddNew.show = false;
      this.modalAddNew.form.resetFields();
      this.modalAddNew.parentTitle = null;
    },
    //编辑保存
    editSave (e) {
      e.preventDefault();
      let _this = this;
      this.editForm.form.validateFields((err, values) => {
        console.log(values, 'valuesvalues');
        if (!err) {
          values.key = this.editForm.keyAddonBefore + values.key;
          values.type = this.editForm.type;
          values.desc = this.editForm.desc;
          values.routerPath = this.editForm.routerPath;
          values.icon = this.editForm.icon;
          values.sort = this.editForm.sort;
          values.menuType = 2;
          this.$confirm({
            title: '确定修改数据吗？',
            content: '点击确定提交',
            onOk () {
              FuncModService.update(_this.tree.currentNodeData.id, values)
                .then(da => {
                  console.log('da', da);
                  _this.$message.info('已保存');
                })
                .catch(e => {
                  console.log('e', e);
                  _this.$message.error(e);
                });
            },
          });
        }
      });
    },
    //刷新tree
    refreshTreeData () {
      FuncModService.treeData('1',2)
        .then(data => {
          this.tree.data = data;
          //当前选中
          if (data && data.length > 0) {
            this.$nextTick(() => {
              this.tree.defaultSelectedKeys.push(data[0].key);
              this.tree.currentNodeData = data[0];
              //计算key 前缀
              let keys = data[0].key.split('-');
              let suffixKey = keys[keys.length - 1];
              keys.pop();
              let prefix = '';
              for (let key of keys) {
                prefix += key + '-';
              }
              this.$nextTick(() => {
                this.editForm.form.setFieldsValue({
                  title: data[0].title,
                  key: suffixKey,
                  enable: data[0].enable ? 1 : 0,
                });
                this.editForm.keyAddonBefore = prefix;
                this.editForm.desc = data[0].desc;
              });
            });
          }
        })
        .catch(e => {
          console.log('获取数据失败...', e);
          this.$message.error(e);
        });
    },
    //删除模块
    deleteMod () {
      let _this = this;
      this.$confirm({
        title: '确定删除该模块？',
        content: '点击确定删除',
        onOk () {
          FuncModService.deleteMod(_this.tree.currentNodeData.id)
            .then(da => {
              _this.$message.info('已删除');
              _this.refreshTreeData();
            })
            .catch(e => {
              console.log('e', e);
              _this.$message.error(e);
            });
        },
      });
    },
  },

};
</script>

<style scoped lang="less">
.page {
  padding: 8px 0;
}
</style>
